"use client";
import { type Context, createContext } from "react";

import type {
  IOspApiClientContext,
  IOspApiClientProviderProps,
} from "../types";
import { useCreateOspApi } from "@hooks";

export const OspApiClientContext: Context<IOspApiClientContext> =
  createContext<IOspApiClientContext>({});

export const OspApiClientProvider = ({
  children,
}: IOspApiClientProviderProps) => {
  const {
    openApiClient,
    questApiClient,
    chatApiClient,
    aiApiClient,
    notifyApiClient,
    swapApiClient,
    openDataApiClient,
    memberApiClient,
    trackerApiClient,
  } = useCreateOspApi();
  return (
    <OspApiClientContext.Provider
      value={{
        openApi: openApiClient,
        aiApi: aiApiClient,
        questApi: questApiClient,
        chatApi: chatApiClient,
        notifyApi: notifyApiClient,
        swapApi: swapApiClient,
        openDataApi: openDataApiClient,
        memberApi: memberApiClient,
        trackerApi: trackerApiClient,
      }}
    >
      {children}
    </OspApiClientContext.Provider>
  );
};
